import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './helpers/plugins'

import NProgress from 'nprogress/nprogress.js'
import 'nprogress/nprogress.css'

import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

Vue.config.productionTip = false

// HELPERS
import helpers from './helpers/helpers'
Vue.mixin(helpers)

router.beforeResolve((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
